import React, { useContext, useMemo } from "react";
import {
  useGetIdentity,
} from "@refinedev/core";
import { HamburgerMenu } from "./hamburgerMenu";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import type { RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { Brightness4, BrightnessHigh } from "@mui/icons-material";
import { ColorModeContext } from "@/contexts";
import { IContact } from "@/utils/zod/contactFormValidation";
import palette from "@/palette";

export const ThemedHeaderV2: React.FC<RefineThemedLayoutV2HeaderProps> = () => {
  const { mode, setMode } = useContext(ColorModeContext);

  // const changeLanguage = useSetLocale();
  // const locale = useGetLocale();
  // const currentLocale = locale();
  const { data: user } = useGetIdentity<IContact | null>();

  // Generate a random background color from the palette variants
  const randomBackgroundColor = useMemo(() => {
    const colorOptions = ['primary', 'info', 'success', 'error'] as const;
    const randomIndex = Math.floor(Math.random() * colorOptions.length);
    const selectedColor = colorOptions[randomIndex];
    return palette.dark[selectedColor].dark;
  }, []);

  return (
    <AppBar
      color="default"
      position="sticky"
      elevation={0}
      sx={{
        "& .MuiToolbar-root": {
          minHeight: "64px",
        },
        height: "64px",
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        backgroundColor: (theme) => theme.palette.background.paper,
      }}
    >
      <Toolbar
        sx={{
          paddingLeft: {
            xs: "0",
            sm: "16px",
            md: "24px",
          },
        }}
      >
        <Box
          minWidth="40px"
          minHeight="40px"
          marginRight={{
            xs: "0",
            sm: "16px",
          }}
          sx={{
            "& .MuiButtonBase-root": {
              marginLeft: 0,
              marginRight: 0,
            },
          }}
        >
          <HamburgerMenu />
        </Box>
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          gap={{
            xs: "8px",
            sm: "24px",
          }}
        >
          <Stack direction="row" flex={1}>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={{
              xs: "8px",
              sm: "24px",
            }}
          >
            {/* <Select
              size="small"
              disableUnderline
              defaultValue={currentLocale}
              slotProps={{
                input: {
                  "aria-label": "Without label",
                },
              }}
              variant="outlined"
              sx={{
                width: {
                  xs: "120px",
                  sm: "160px",
                },
              }}
            >
              {[...(i18n.languages ?? [])].sort().map((lang: string) => (
                <MenuItem
                  selected={currentLocale === lang}
                  key={lang}
                  defaultValue={lang}
                  onClick={() => {
                    changeLanguage(lang);
                  }}
                  value={lang}
                >
                  <Typography color="text.secondary">
                    {getLanguageFullName(lang)}
                  </Typography>
                </MenuItem>
              ))}
            </Select> */}

            <IconButton
              onClick={() => {
                setMode();
              }}
              sx={{
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "transparent" : "#00000014",
              }}
            >
              {mode === "dark" ? (
                <BrightnessHigh />
              ) : (
                <Brightness4
                  sx={{
                    fill: "#000000DE",
                  }}
                />
              )}
            </IconButton>

            <Stack
              direction="row"
              gap={{
                xs: "8px",
                sm: "16px",
              }}
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                fontSize={{
                  xs: "12px",
                  sm: "14px",
                }}
                variant="subtitle2"
              >
                {user?.name}
              </Typography>
              <Avatar 
                src={user?.user?.avatar_url || ""} 
                alt={user?.user?.name || ""}
                sx={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: randomBackgroundColor,
                }}
              >
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
            </Stack>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
